export const SyncJobsActionTypes = {
    API_RESPONSE_SUCCESS: '@@sync-jobs/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@sync-jobs/API_RESPONSE_ERROR',
    GET_ALL_SYNC_JOBS: '@@sync-jobs/GET_ALL_SYNC_JOBS',
    RESET_ALL_SYNC_JOBS_ERRORS: '@@sync-jobs/RESET_ALL_SYNC_JOBS_ERRORS',
};
